import { ConfirmPasswordRoutes } from '@/repository/auth';
const { CheckPasswordIsCorrect, CheckPasswordIsConfirmed } = ConfirmPasswordRoutes;

export default {
	namespaced: true,
	actions: {
		async store({ },data) {
			try {
				return await CheckPasswordIsCorrect(data)
			}
			catch (error) {
				console.error('Password could not be confirmed.', error);
				throw error;
			}
		},
		async show({ }) {
			try {
				return await CheckPasswordIsConfirmed()
			}
			catch (error) {
				console.error('Could not check if password has been confirmed.', error);
				throw error;
			}
		}
	}
}